import React from "react";

const CardShimmer = () => {
  return (
    <div className="border border-gray-100 rounded-xl p-4 max-w-xl bg-white shadow-sm space-y-4   relative">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-3">
          <div className="w-8 h-6 shimmer rounded-md" />
          <div className="w-24 h-4 shimmer rounded-md" />
        </div>
        <div className="w-16 h-4 shimmer rounded-md" />
      </div>

      {/* Description */}
      <div className="flex items-center gap-2">
        <div className="w-5 h-5 shimmer rounded-full" />
        <div className="w-full h-4 shimmer rounded-md" />
      </div>

      {/* Details row */}
      <div className="flex items-center gap-6">
        <div className="flex items-center gap-1">
          <div className="w-5 h-5 shimmer rounded-full" />
          <div className="w-16 h-4 shimmer rounded-md" />
        </div>

        <div className="flex items-center gap-1">
          <div className="w-5 h-5 shimmer rounded-full" />
          <div className="w-6 h-4 shimmer rounded-md" />
        </div>

        <div className="flex items-center gap-1">
          <div className="w-5 h-5 shimmer rounded-full" />
          <div className="w-16 h-4 shimmer rounded-md" />
        </div>

        <div className="ml-auto w-16 h-4 shimmer rounded-md" />
      </div>

      {/* Action buttons */}
      <div className="flex flex-col xl:flex-row gap-4 pt-2 border-t border-gray-200">
        <div className="flex-1 h-8 shimmer rounded-md" />
        <div className="flex-1 h-8 shimmer rounded-md" />
      </div>
    </div>
  );
};

export default CardShimmer;
